export default "__VITE_ASSET__BdqTvfEc__"